import * as React from "react"
export const Svg_055 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={58}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M4.272 55.734c0 1.25 1.034 2.266 2.305 2.266H46.89v-4.532H6.577c-1.27 0-2.305 1.016-2.305 2.266Z"
    />
    <path fill="url(#b)" d="M54.728 8.71V0h-4.38v11.6l4.38-2.89Z" />
    <path fill="url(#c)" d="M16.375 11.33h18.413v14.943H16.375V11.331Z" />
    <path fill="url(#d)" d="m54.728 12.804-4.38 2.89v8.498l4.38-2.89v-8.498Z" />
    <path
      fill="url(#e)"
      d="M46.89 50.068V0H9.46c-2.86 0-5.187 2.287-5.187 5.099V50.54a5.815 5.815 0 0 1 2.305-.473H46.89ZM12.917 7.932h25.328v21.74H12.917V7.933Zm0 25.14h25.328v3.4H12.917v-3.4Zm0 6.799h25.328v3.399H12.917v-3.4Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={14.127}
        x2={14.442}
        y1={54.148}
        y2={58.941}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={51.361}
        x2={56.843}
        y1={1.74}
        y2={5.09}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={20.633}
        x2={26.992}
        y1={13.572}
        y2={26.256}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={51.361}
        x2={56.788}
        y1={14.512}
        y2={17.89}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={14.127}
        x2={39.724}
        y1={7.581}
        y2={42.513}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)